export function getTicketsCount(count: number) {
  return count > 9 ? '9+' : count;
}
